import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import App from "./App";
import Login from "./components/Login";
import LoggedOutHome from "./components/LoggedOutHome";

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    height: 100%;
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box;
  }
  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-width: 100vw;
    font-family: "Inter", sans-serif;
  }
  .maplibregl-ctrl-top-right {
    right: 10px !important;
    top: 10px !important;
  }
  .maplibregl-popup-close-button {
    outline: none !important;
    &:focus {
      outline: none !important;
    }
  }
  .maplibregl-canvas-container {
    outline: none !important;
    &:focus {
      outline: none !important;
    }
  }
  .maplibregl-canvas {
    outline: none !important;
    box-shadow: none !important;
  }
`;

export default function Router() {
  return (
    <Routes>
      <Route
        path="/app"
        element={
          <>
            <GlobalStyle />
            <App />
          </>
        }
      />
      <Route
        path="/login"
        element={
          <>
            <GlobalStyle />
            <Login />
          </>
        }
      />
      <Route
        path="/"
        exact
        element={
          <>
            <GlobalStyle />
            <LoggedOutHome />
          </>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
